module.exports = __webpack_public_path__ + "static/media/icon_book.6fe185f1.svg";